const UPDATE_FLASH_PROGRESS = 'scratch-gui/flash-progress/UPDATE_FLASH_PROGRESS';
const RESET_FLASH_PROGRESS = 'scratch-gui/flash-progress/RESET_FLASH_PROGRESS';

const initialState = {
    fileIndex: 0,
    percent: 0
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case UPDATE_FLASH_PROGRESS:
        return Object.assign({}, state, {
            fileIndex: action.fileIndex,
            percent: action.percent
        });
    case RESET_FLASH_PROGRESS:
        return initialState;
    default:
        return state;
    }
};

const updateFlashProgress = function (fileIndex, percent) {
    return {
        type: UPDATE_FLASH_PROGRESS,
        fileIndex: fileIndex,
        percent: percent
    };
};

const resetFlashProgress = function () {
    return {
        type: RESET_FLASH_PROGRESS
    };
};

export {
    reducer as default,
    initialState as flashProgressInitialState,
    updateFlashProgress,
    resetFlashProgress
};
